import { action, computed, makeObservable } from 'mobx'
import { Observable } from 'rxjs'
import { AlertFactory } from 'alerts/Alert'
import DocumentStore from 'documents/DocumentStore'
import DocumentTypeStore from 'documents/DocumentTypeStore'
import { DocumentDetailsRootViewModel } from 'documents/views/DocumentRoot/DocumentDetailsRootViewModel'
import Member from 'iam/models/Member'
import { GetCurrentMember } from 'iam/SessionStore'
import { Membership } from 'iam/WorkspaceMembershipStore'
import { FilterStorageFactory } from 'infra/FiltersViewModel'
import JobStore from 'jobs/JobStore'
import JobSearchStore from 'jobs/views/JobManagement/JobSearchStore'
import { DocumentManagementViewModel } from '../DocumentManagementTable/DocumentManagementViewModel'
import { Id } from 'types/definitions'

export class DocumentsTabViewModel {
  documentManagementVM = new DocumentManagementViewModel(
    () => this.userPublicId(),
    () => this.userMemberships(),
    () => this.currentUserMemberships(),
    this.documentDetailsRootVM,
    this.documentStore,
    this.documentTypeStore,
    this.jobStore,
    this.jobSearchStore,
    this.currentMember$,
    this.getCurrentMember,
    this.createFilterStorage,
    this.newAlert,
  )

  constructor(
    private userPublicId: () => Id,
    private userMemberships: () => Membership[],
    private currentUserMemberships: () => Membership[],
    private documentDetailsRootVM: DocumentDetailsRootViewModel,
    private documentStore: DocumentStore,
    private documentTypeStore: DocumentTypeStore,
    private jobStore: JobStore,
    private jobSearchStore: JobSearchStore,
    private currentMember$: Observable<Member>,
    private getCurrentMember: GetCurrentMember,
    private createFilterStorage: FilterStorageFactory,
    private newAlert: AlertFactory,
  ) {
    makeObservable(this)
  }

  /**
   * Activates the view model.
   */
  activate() {
    this.documentManagementVM.activate()
  }

  /**
   * Deactivates the view model.
   */
  deactivate() {
    this.documentManagementVM.deactivate()
  }

  @computed
  get isSearchFilterApplied() {
    const isSearching =
      this.documentManagementVM.searcher.searchText.value !== ''
    const haveFiltersApplied =
      this.documentManagementVM.searcher.filters.appliedFilterCount > 0

    return isSearching || haveFiltersApplied
  }

  @computed
  get shouldShowEmptyState() {
    return (
      this.documentManagementVM.searcher.scroller.isDone &&
      this.documentManagementVM.searcher.documents.length === 0
    )
  }

  /**
   * Clears any search filters.
   */
  @action.bound
  clearFilters() {
    this.documentManagementVM.searcher.clearFilters()
  }
}
